import logo from "../adsk-logo.png";


const Navbar = () => {

    return (
        <nav className="sticky top-0 z-50 px-6 py-8 backdrop-blur-lg border-b border-neutral-700/80 dark:bg-black flex justify-between items-center fixed-top">
            {/* Logo and Site Name */}
            <div className="flex flex-wrap justify-between items-center ml-10">
                <img className="h-5 w-30 mr-2" src={logo} alt="Logo" />
                {/* <span className="text-2xl font-medium tracking-tight">Autodesk</span> */}
            </div>
        </nav>
    )
}

export default Navbar;